import {
  ACTIVARTOTP_ERROR,
  ACTIVARTOTP_LOADING,
  ACTIVARTOTP_SUCCESS,
  ACTIVARTOTP_RESET,
  RESET_CONTEXT,
} from "../ActionTypes";

import activarTotpInitialState from "../initialStates/activarTotpInitialState";

const activarTotp = (state, { payload, type }) => {
  switch (type) {
    case ACTIVARTOTP_LOADING:
      return {
        ...state,
        activarTotp: {
          ...state.activarTotp,
          error: false,
          loading: true,
        },
      };
    case ACTIVARTOTP_SUCCESS:
      return {
        ...state,
        activarTotp: {
          ...state.activarTotp,
          loading: false,
          error: false,
          data: payload,
        },
      };
    case ACTIVARTOTP_ERROR:
      return {
        ...state,
        activarTotp: {
          ...state.activarTotp,
          error: payload,
          loading: false,
        },
      };

    case ACTIVARTOTP_RESET:
      return activarTotpInitialState;
    case RESET_CONTEXT:
      return activarTotpInitialState;

    default:
      return state;
  }
};

export default activarTotp;
